import { FlexDiv, P } from 'components/generic/HomePageComponents'

/**
 * @export SimpleErrorPage
 * @description Generates a simple error page that is not erliant on any BE data.
 * @extends {Component}
 */
const SimpleErrorPage = () => (
  <FlexDiv
    flexDirection={['column', 'column', 'row']}
    justifyContent='center'
    alignItems='center'
    mt='100px'
    mb='100px'
  >
    <FlexDiv alignItems='center' flexDirection='column'>
      <P fontSize='55px' fontWeight='bold' maxWidth='90vw' pr='20px' mb='0'>
        Error
      </P>
      <P lineHeight='38px' fontSize='40px' maxWidth='90vw' m='10px'>
        {`
          An error occcured. We're looking into it. Please try again later!
        `}
      </P>
    </FlexDiv>
  </FlexDiv>
)
export default SimpleErrorPage
